import { PrivateInterceptor } from "../../../Base/interceptors/PrivateInterceptor";
import { PrivateInterceptorsPR } from "../../../Base/interceptors/PrivateinterceptorsPR";


export const getHeadCount = async (mes, ano) => {
   return await PrivateInterceptor(`RRHH/headCount/getHeadCount/${mes}/${ano}`, 'GET')
}

export const getPersonalPorArea = async () => {
   return await PrivateInterceptor(`RRHH/headCount/personalPorArea`, 'GET')
}

export const getPersonalPorAreaGeneral = async () => {
   return await PrivateInterceptor(`RRHH/headCount/personalPorAreaGeneral`, 'GET')
}